import { isArray } from 'lodash';

/*
Removes sensitive data (AccountNumber, Cvv, ExpiryDate) from formBean and saves it
inside formBean.__ui__only.sensitiveInfo
 */

export function removeSensitiveData(formBean:any){
  //TODO: Revisit and make this more generic by adding a flag to domain metadata in future
  let paymentMethodDomainObj = formBean.DomainObject && formBean.DomainObject['Payment'] && formBean.DomainObject['Payment']['PaymentMethod'] ? formBean.DomainObject['Payment']['PaymentMethod'] : null;

  if(paymentMethodDomainObj && !isArray(paymentMethodDomainObj)){
      if((paymentMethodDomainObj['AccountNumber'] || paymentMethodDomainObj['Cvv'] || paymentMethodDomainObj['ExpiryDate'])){
        if(!formBean.__ui__only) formBean.__ui__only = {}; // Just in case.
        formBean.__ui__only.sensitiveInfo = {};
        if(paymentMethodDomainObj['AccountNumber']) {
          formBean.__ui__only.sensitiveInfo['AccountNumber'] = paymentMethodDomainObj['AccountNumber'];
          paymentMethodDomainObj['AccountNumber'] = null;
        }
        if(paymentMethodDomainObj['Cvv']) {
          formBean.__ui__only.sensitiveInfo['Cvv'] = paymentMethodDomainObj['Cvv'];
          paymentMethodDomainObj['Cvv'] = null;
        }
        if(paymentMethodDomainObj['ExpiryDate']) {
          formBean.__ui__only.sensitiveInfo['ExpiryDate'] = paymentMethodDomainObj['ExpiryDate'];
          paymentMethodDomainObj['ExpiryDate'] = null;
        }
      }
  } else console.log("Skipped removing sensistive data.")
}


/*
  Stores the sensitive attribute values in the state temporarily because the backend will not have them in the response.
  AccountNumber, ExpiryDate, Cvv
 */
export function saveSensitiveData(formBean:any){
  let paymentMethodDomainObj = formBean.DomainObject && formBean.DomainObject['Payment'] && formBean.DomainObject['Payment']['PaymentMethod'] ? formBean.DomainObject['Payment']['PaymentMethod'] : null;

  if(paymentMethodDomainObj){
    if(paymentMethodDomainObj['AccountNumber'] || paymentMethodDomainObj['Cvv'] || paymentMethodDomainObj['ExpiryDate']){
      if(!formBean.__ui__only) formBean.__ui__only = {}; // Just in case.
      formBean.__ui__only.sensitiveInfo = {};
      if(paymentMethodDomainObj['AccountNumber']) formBean.__ui__only.sensitiveInfo['AccountNumber'] = paymentMethodDomainObj['AccountNumber'];
      if(paymentMethodDomainObj['Cvv']) formBean.__ui__only.sensitiveInfo['Cvv'] = paymentMethodDomainObj['Cvv'];
      if(paymentMethodDomainObj['ExpiryDate']) formBean.__ui__only.sensitiveInfo['ExpiryDate'] = paymentMethodDomainObj['ExpiryDate'];

    }
  }else console.log("skipping save sensitive data");
}


/*
 Adds back the sensitive data to the formBean that has been removed from formBean.
 */
export function postProcess(formBean:any){
  let paymentMethodDomainObj = formBean.DomainObject && formBean.DomainObject['Payment'] && formBean.DomainObject['Payment']['PaymentMethod'] ? formBean.DomainObject['Payment']['PaymentMethod'] : null;
  let formBeanPaymentMethodObj = formBean.DomainObject && formBean.DomainObject['Payment'] && formBean.DomainObject['Payment']['PaymentMethod'] ? formBean.DomainObject['Payment']['PaymentMethod'] : null;

  if(!paymentMethodDomainObj || !formBeanPaymentMethodObj){
    console.log("Skipped post processing");
  }else{
    let uiStoredAccountNumber = formBean.__ui__only && formBean.__ui__only.sensitiveInfo && formBean.__ui__only.sensitiveInfo['AccountNumber'] ? formBean.__ui__only.sensitiveInfo['AccountNumber'] : null;
    let uiStoredCvv = formBean.__ui__only && formBean.__ui__only.sensitiveInfo && formBean.__ui__only.sensitiveInfo['Cvv'] ? formBean.__ui__only.sensitiveInfo['Cvv'] : null;
    let uiStoredExpiryDate = formBean.__ui__only && formBean.__ui__only.sensitiveInfo && formBean.__ui__only.sensitiveInfo['ExpiryDate'] ? formBean.__ui__only.sensitiveInfo['ExpiryDate'] : null;


    if(uiStoredAccountNumber !== paymentMethodDomainObj['AccountNumber']) formBeanPaymentMethodObj['AccountNumber'] = uiStoredAccountNumber;
    if(uiStoredCvv !== paymentMethodDomainObj['Cvv']) formBeanPaymentMethodObj['Cvv'] = uiStoredCvv;
    if(uiStoredExpiryDate !== paymentMethodDomainObj['ExpiryDate']) formBeanPaymentMethodObj['ExpiryDate'] = uiStoredExpiryDate;
  }
}